<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="appointmentOrderVO.pkid > 0 ? '编辑':'新建'"
        width="1200px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="appointmentOrderVO"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-tabs type="border-card">
          <el-tab-pane label="预约信息">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :lg="6">
                <el-form-item label="系统编号">
                  <el-input v-model="appointmentOrderVO.billNo"/>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :lg="6">
                <el-form-item label="登记日期">
                  <el-date-picker
                      v-model="appointmentOrderVO.creatTime"
                      style="width: 190px"
                      type="datetime"
                      disabled
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="选择日期"/>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :lg="6">
                <el-form-item label="登 记 人">
                  <el-input v-model="appointmentOrderVO.creatorName" disabled/>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :lg="6">
                <el-form-item label="预约日期">
                  <el-date-picker
                      v-model="appointmentOrderVO.appointmentTime"
                      style="width: 190px"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="选择日期"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :lg="12">
                <el-form-item label="客户名称" prop="customerName">
                  <el-input v-model="appointmentOrderVO.customerName" readonly placeholder="请输入" clearable>
                    <el-button slot="append" icon="el-icon-search" style="margin-left: 2%;" @click="$refs.selectCustomer.open()">选择</el-button>
                  </el-input>
                  <customer-select ref="selectCustomer" @select="selectCustomer"/>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :lg="6">
                <el-form-item label="销售员" prop="salesmanName">
                  <el-select
                      v-model="appointmentOrderVO.salesmanName"
                      filterable
                      clearable
                      size="mini"
                      placeholder="请选择">
                    <el-option
                        v-for="item in salesmanList"
                        :key="item.systemUserID"
                        :label="item.employeeName+'/'+item.departmentName"
                        :value="item.employeeName"
                        @click.native="selectSalesman(item)"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :lg="6">
                <el-form-item label="销售联系方式">
                  <el-input v-model="appointmentOrderVO.salesMobile"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :lg="6">
                <el-form-item label="出厂编号" prop="factoryNo">
                  <el-input v-model="appointmentOrderVO.factoryNo"/>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :lg="6">
                <el-form-item label="现场名称" prop="siteName">
                  <el-input v-model="appointmentOrderVO.siteName"/>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :lg="6">
                <el-form-item label="现场联系人" prop="contact">
                  <el-input v-model="appointmentOrderVO.contact"/>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :lg="6">
                <el-form-item label="现场联系方式" prop="siteMobile">
                  <el-input v-model="appointmentOrderVO.siteMobile"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :lg="6">
                <el-form-item label="项目负责人">
                  <el-input v-model="appointmentOrderVO.projectLeader"/>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :lg="12">
                <el-form-item label="服务地址" prop="serviceAddress">
                  <el-input v-model="appointmentOrderVO.serviceAddress"/>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="vm-separate">
              <el-form-item label="服务性质" prop="appointmentItems1">
                <el-checkbox-group v-model="appointmentOrderVO.appointmentItems1" @change="natureTypeChange">
                  <el-checkbox v-for="item in appointmentItemTemplates1" :key="item.pkid" :label="item.itemName">{{item.itemName}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item v-if="appointmentOrderVO.appointmentItems1.length>0 && appointmentOrderVO.appointmentItems1.toString().includes('其他')" label="其他性质">
                <el-input v-model="appointmentOrderVO.natureNote" placeholder="请输入"/>
              </el-form-item>
            </div>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :lg="6">
                <el-form-item label="服务台数" prop="serviceQuantity">
                  <el-input v-model="appointmentOrderVO.serviceQuantity"/>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :lg="6">
                <el-form-item label="主板型号" prop="mainBoardModel">
                  <el-input v-model="appointmentOrderVO.mainBoardModel"/>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :lg="12">
                <el-form-item label="变频器型号" prop="transducerModel">
                  <el-input v-model="appointmentOrderVO.transducerModel"/>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="vm-separate">
              <el-form-item label="服务原因" prop="appointmentItems2">
                <el-checkbox-group v-model="appointmentOrderVO.appointmentItems2">
                  <el-checkbox v-for="item in appointmentItemTemplates2" :key="item.pkid" :label="item.itemName">{{item.itemName}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
            <el-form-item v-if="appointmentOrderVO.appointmentItems2.length>0 && appointmentOrderVO.appointmentItems2.toString().includes('其他')" label="其他原因">
              <el-input v-model="appointmentOrderVO.causeNote" placeholder="请输入"/>
            </el-form-item>
            <el-form-item label="故障描述" prop="faultNote">
              <el-input
                  v-model="appointmentOrderVO.faultNote"
                  placeholder="维修必填"
                  type="textarea"
                  max="150"/>
            </el-form-item>
            <div>
              <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">订单附件</div>
              <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
                <el-upload
                    :action="actionUrl"
                    :on-success="handleSuccess"
                    :on-remove="handleRemove"
                    :on-error="handlerError"
                    :file-list="files"
                    :show-file-list="false">
                  <el-button size="small" type="primary" style="margin: 0 5px 0 0">添加附件</el-button>
                </el-upload>
              </div>
              <el-table
                  v-if="appointmentOrderVO.attachments"
                  ref="payData1"
                  :data="appointmentOrderVO.attachments">
                <el-table-column type="index" align="center" label="行号"/>
                <el-table-column prop="fileName" align="center" label="附件描述">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.fileName" class="tabInput" style="width: 400px;margin: 0 auto;text-align: center"/>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
                  <template slot-scope="scope">
                    <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <customer-select ref="selectCustomer" @select="selectCustomer"/>
        </el-tabs>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import loginUtil from "@/util/loginUtil";
  export default {
    name:"AppointmentEdit",
    components: {CustomerSelect},
    data() {
      return {
        dialogVisible: false,
        uploadLoading: false,
        contentLoading: false,
        submitLoading: false,
        actionUrl: window.config.basicServerHttpUrl + "file/upload",
        files: [],
        fileList: [],
        salesmanList:[],
        appointmentItemTemplates1: [],
        appointmentItemTemplates2: [],
        appointmentOrderVO: {
          pkid: "",
          billNo: "",
          creatTime: "",
          appointmentTime: "",
          creatorName: loginUtil.getName(),
          customerId: "",
          customerName: "",
          salesmanId: "",
          salesmanName: "",
          salesMobile: "",
          salesOrderNo: "", //出厂编号
          siteName: "",
          contact: "",
          siteMobile: "",
          natureNote: "",
          projectLeader: "",
          serviceAddress: "", //服务地址
          serviceQuantity: "", //服务台数
          submitTime: "", //提交日期
          addComment: "", //审核意见
          mainBoardModel: "",
          transducerModel: "",
          causeNote: "",
          faultNote: "",
          attachments: [],
          delayTableData: [],
          appointmentItems1: [],
          appointmentItems2: [],
        },
        ruleValidate: {
          customerName: {required: true, message: "客户名称不能为空",trigger: "blur"},
          salesmanName: {required: true, message: "不能为空",trigger: "blur"},
          factoryNo: {required: true, message: "不能为空",trigger: "blur"},
          siteName: {required: true, message: "不能为空",trigger: "blur"},
          contact: {required: true, message: "不能为空",trigger: "blur"},
          siteMobile: {required: true, message: "不能为空",trigger: "blur"},
          serviceAddress: {required: true, message: "不能为空",trigger: "blur"},
          appointmentItems1: {required: true, message: "不能为空",trigger: "blur"},
          appointmentItems2: {required: true, message: "不能为空",trigger: "blur"},
          serviceQuantity: {required: true, message: "不能为空",trigger: "blur"},
          mainBoardModel: {required: true, message: "不能为空",trigger: "blur"},
          transducerModel: {required: true, message: "不能为空",trigger: "blur"},
          faultNote: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        this.appointmentOrderVO.pkid = row.pkid;
        this.dialogVisible = true;
        if(this.appointmentOrderVO.pkid>0) {
          this.getData();
        }else {
          this.getNo();
        }
        this.getTemplateList();
      },
      getData() {
        this.$http
          .get("basic", `appointmentOrders/${this.appointmentOrderVO.pkid}`)
          .then(resp => {
            this.appointmentOrderVO = resp;
            console.log(this.appointmentOrderVO);
          });
      },
      getTemplateList() {
        this.$http
          .get("basic", "appointmentItemTemplates/getAllList")
          .then(resp => {
            this.appointmentItemTemplates1 = [];
            this.appointmentItemTemplates2 = [];
            resp.forEach(item=>{
              if (item.itemType === 10) {
                this.appointmentItemTemplates1.push(item);
              }else {
                this.appointmentItemTemplates2.push(item);
              }
            });
          });
      },
      natureTypeChange(value) {
        console.log(value);
      },
      getNo() {
        this.$http
          .get("basic", "appointmentOrders/getXYBillNo")
          .then(resp => {
            this.appointmentOrderVO.billNo = resp.data;
          });
      },
      deleteFile(index) {
        this.appointmentOrderVO.attachments.splice(index, 1);
      },
      openFile(item) {
        console.log(item);
        let a = document.createElement("a");
        a.href = "http://emes.stepelectric.com" + item.filePath;
        a.target = "_blank";
        a.download = item.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
      //附件表页面删除
      fileDelete(row,index) {
        console.log(row);
        this.appointmentOrderVO.attachments.splice(index,1);
      },
      handlerError(err, file, fileList) {
        console.log(file);
        console.log(fileList);
        alert(err);
      },
      //附件表页面删除
      oneDelete(row, index) {
        this.appointmentOrderVO.attachments.splice(index, 1);
      },
      handleSuccess(response, file, fileList) {
        console.log(this.appointmentOrderVO);
        file.path = response;
        this.files = fileList;
        let object ={
          fileName:file.path.originalName,
          filePath:file.path.fullPath,
        };
        this.appointmentOrderVO.attachments.push(object);
      },
      handleRemove(file, fileList) {
        this.files = fileList;
      },
      selectCustomer(row) {
        console.log(row);
        this.appointmentOrderVO.customerName = row.customerName;
        this.appointmentOrderVO.customerId = row.customerID;
        this.getSalesmanList(row.customerID);
      },
      getSalesmanList(customerID) {
        this.salesmanList = [];
        this.$http
          .get("basic", `customerBelongtoEmployees/getByCustomerId/${customerID}`)
          .then(res => {
            console.log(res);
            if (res.length !== 0) {
              this.salesmanList = res;
            } else {
              this.getUserList();
            }
          });
      },
      getUserList() {
        this.$http
          .get("basic", "system/user/getUserList")
          .then(res => {
            console.log(res);
            this.salesmanList = [];
            this.salesmanList = res;
          });
      },
      selectSalesman(item) {
        console.log(item);
        this.appointmentOrderVO.salesmanId = item.systemUserID;
        this.appointmentOrderVO.salesName = item.employeeName;
        this.appointmentOrderVO.departmentName = item.departmentName;
        this.appointmentOrderVO.salesMobile = item.mobile;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.appointmentOrderVO.isSubmit = false;
            console.log(this.appointmentOrderVO);
            if(this.appointmentOrderVO.pkid>0) {
              this.$http
                .put("basic", "appointmentOrders", this.appointmentOrderVO)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }else {
              this.$http
                .post("basic", "appointmentOrders", this.appointmentOrderVO)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
